import { QuizFormLayoutWidgetRegistrationService } from './features/quizzes/services/quiz-form-layout-widget-registration.service';
import { QuizFormLayoutWidgetComponent } from './features/quizzes/components/question-form-layout-widget/quiz-form-layout-widget.component';
// tslint:disable-next-line: max-line-length
import { Inject, Injectable, Injector } from '@angular/core';
import { QuestionFormLayoutWidgetRegistrationService } from './features/quizzes/services/question-form-layout-widget-registration.service';
import { QuestionFormLayoutWidgetComponent } from './features/quizzes/components/question-form-layout-widget/question-form-layout-widget.component';
import { DwCoreConfig, DwAuthGuardService, DwAuthenticationType, DwConfig, DwUIMetaDataConfigDefaults, DwConfigServiceToken, DwUIConfig, DwAgGridComponent, DwUIMetaDataConfig, DwConfigProviderBase, DwUiConfigName, DwCoreConfigDefaults, DwAttributeType, DwControlType, DwMediaConfigName, DwMediaConfig, DwFormDebugService, DwLogSeverity, DwUiConfigInitDecorator, DwUiConfigRegistryService, DwConfigService, DwUiRegistryType, DwUiGridStyleReference, DwMenu, DwBreadcrumbMenu, DwSecurityState, DwUserInactivityConfig, DwSecurityUserService, DwEventService, DwOrmDataService, getUiLoadingConfigKey, DwUiConfigType, DwFormSkeletonLoadingConfig } from '@devwareapps/devware-cap';
import { DwEnvironmentInfo } from '@devwareapps/devware-cap/devware-core/app-init/models/dw-environment-info.model';
import { environment } from 'src/environments/environment';
import { AppPermissions } from './meta-data/app-permissions.enum';
import { EnvironmentConfigItem } from 'src/environments/models/environment-config.model';
import { EnvironmentNames } from 'src/environments/models/environment-names.enum';
import { AdminManagerService } from './features/admin/services/admin-manager.service';
import { AviatorOnlineUserTypeIds } from './features/shared/models/aviator-user-type.enum';
import { EventManagementService } from './features/shared/util/event-management.service';
import { AppMetaDataItemNames, SubscriptionFeatureKeys } from './meta-data/app-meta-data.service';
import { of } from 'rxjs';
import { SchoolRepositoryService } from './features/schools/services/school-repository.service';
import { map } from 'rxjs/operators';
import { AviatorRouteGuardService } from './features/shared/route-guards/aviator-route-guard.service';
import { angularApplicationVersion } from './app-version';
import { DwLoginRegistrationInfoProviderService } from './features/homepage/services/dw-login-registration-info-provider.service';
import { Router } from '@angular/router';
import { DwPubSubEventTopics } from './features/z-devware/pubsub/models/dw-pub-sub-event-topics.model';
import { DwPubSubService } from './features/z-devware/pubsub/dw-pub-sub-service';
import { ACSSubmissionUtilService } from './features/students/services/acs-submission-util.service';
@DwConfig()
@Injectable()
export class AppDevwareConfigProviderService extends DwConfigProviderBase {
    private status
    private static runtimeEnvironmentInfo: DwEnvironmentInfo;
    environmentConfigItem: EnvironmentConfigItem;

    static getEnvironmentBaseTitle(): string {
        const appTitle = (environment as any).appTitle || environment.baseTitle || 'AviatorPro';
        const environmentConfig = AppDevwareConfigProviderService.getTitleEnvironmentConfig();
        const environmentLabel = (environmentConfig?.environmentLabel || '').trim();
        const environmentOrb = AppDevwareConfigProviderService.getEnvironmentOrb(environmentConfig);

        if (AppDevwareConfigProviderService.isLocalHost()) {
            const localPrefix = environmentOrb ? `${environmentOrb} ✦` : '✦';

            if (environmentLabel && environmentLabel !== 'LOCAL') {
                return `${localPrefix} ${appTitle} [LOCAL -> ${environmentLabel}]`;
            }

            return `${localPrefix} ${appTitle} [LOCAL]`;
        }

        if (environmentConfig?.envKey && environmentConfig.envKey !== EnvironmentNames.prod && environmentLabel) {
            return environmentOrb ? `${environmentOrb} ${appTitle} [${environmentLabel}]` : `${appTitle} [${environmentLabel}]`;
        }

        return appTitle;
    }

    static getEnvironmentBaseTitleForRuntime(environmentInfo: DwEnvironmentInfo): string {
        AppDevwareConfigProviderService.runtimeEnvironmentInfo = environmentInfo;

        const appTitle = (environment as any).appTitle || environment.baseTitle || 'AviatorPro';
        const runtimeEnvironmentConfig = AppDevwareConfigProviderService.getRuntimeEnvironmentConfig()
            || AppDevwareConfigProviderService.getEnvironmentConfigItem();
        const environmentLabel = (runtimeEnvironmentConfig?.environmentLabel || '').trim();
        const environmentOrb = AppDevwareConfigProviderService.getEnvironmentOrb(runtimeEnvironmentConfig);
        const isLocalUi = AppDevwareConfigProviderService.isLocalHost();
        const isLocalApi = AppDevwareConfigProviderService.isLocalApi();

        if (isLocalUi) {
            const localMarker = isLocalApi ? '◆◆' : '✦';
            const localLabel = isLocalApi ? 'LOCAL UI/API' : 'LOCAL';
            const localPrefix = environmentOrb ? `${environmentOrb} ${localMarker}` : localMarker;

            if (environmentLabel && environmentLabel !== 'LOCAL') {
                return `${localPrefix} ${appTitle} [${localLabel} -> ${environmentLabel}]`;
            }

            return `${localPrefix} ${appTitle} [${localLabel}]`;
        }

        if (runtimeEnvironmentConfig?.envKey && runtimeEnvironmentConfig.envKey !== EnvironmentNames.prod && environmentLabel) {
            return environmentOrb ? `${environmentOrb} ${appTitle} [${environmentLabel}]` : `${appTitle} [${environmentLabel}]`;
        }

        return appTitle;
    }

    constructor(
        private uiConfigRegistyService: DwUiConfigRegistryService,
        @Inject(DwConfigServiceToken) private dwConfigService: DwConfigService,
        private eventManagementService: EventManagementService,
        private injector: Injector,
        private router: Router,
        //private dwPubSubService: DwPubSubService,
        private dwEventService: DwEventService,

        // private adminManagerService: AdminManagerService,
    ) {
        super();
        // this.setupRegistrations();

        this.setupReplicatedEvents();
    }

    setupReplicatedEvents() {
        this.eventManagementService.addEventReplicator({
            itemName: AppMetaDataItemNames.FlightSchool,
            replicateItemNames: [AppMetaDataItemNames.FlightSchoolBranding, AppMetaDataItemNames.DwTheme, AppMetaDataItemNames.Course, AppMetaDataItemNames.Package]
        });

        this.eventManagementService.addEventReplicator({
            itemName: AppMetaDataItemNames.DwUser,
            replicateItemNames: [AppMetaDataItemNames.DwUserRole, 'dw_SecurityAudit', AppMetaDataItemNames.Student]
        });

        this.eventManagementService.addEventReplicator({
            itemName: AppMetaDataItemNames.CoursePurchase,
            replicateItemNames: [AppMetaDataItemNames.DwUser, AppMetaDataItemNames.Student, AppMetaDataItemNames.StudentCourse, AppMetaDataItemNames.Course, AppMetaDataItemNames.Package]
        });

        this.eventManagementService.addEventReplicator({
            itemName: AppMetaDataItemNames.CourseModule,
            replicateItemNames: [AppMetaDataItemNames.CourseLesson]
        });

        this.eventManagementService.addEventReplicator({
            itemName: AppMetaDataItemNames.Course,
            replicateItemNames: [AppMetaDataItemNames.CourseModule, AppMetaDataItemNames.CourseLesson]
        });

        this.eventManagementService.addEventReplicator({
            itemName: AppMetaDataItemNames.JoinRequestEmail,
            replicateItemNames: [AppMetaDataItemNames.JoinRequestCoursePurchase]
        });

        // InstructorStudent is a relationship item. Changes affect lookups rooted at both
        // parent items, including the assignment Student lookup used by instructors.
        this.eventManagementService.addEventReplicator({
            itemName: AppMetaDataItemNames.InstructorStudent,
            replicateItemNames: [AppMetaDataItemNames.Student, AppMetaDataItemNames.Instructor]
        });

        this.dwEventService.getEventData(DwPubSubEventTopics.messageReceived(ACSSubmissionUtilService.ACS_WRITTEN_RESULT_TOPIC)).subscribe((event) => {
            console.log('AcsWrittenResult message received - Event replicator');

            this.dwEventService.publishEvent(DwOrmDataService.ORM_EVENT_TOPICS.ItemChangedTopic(AppMetaDataItemNames.AcsWrittenResult), {});
        })
    }

    configureCoreConfig(dwCoreConfig: DwCoreConfig) {
        // Set Core configuration values
        dwCoreConfig.baseTitle = AppDevwareConfigProviderService.getEnvironmentBaseTitle();
        //dwCoreConfig.apiRoot = environment.apiRoot;

        this.environmentConfigItem = AppDevwareConfigProviderService.getEnvironmentConfigItem();
        if (!this.environmentConfigItem) {
            console.error('No environment config item found');
            return;
        }

        dwCoreConfig.apiRoot = this.environmentConfigItem.apiRoot;

        dwCoreConfig.applicationVersion = angularApplicationVersion;

        // handled in media config
        // if (this.environmentConfigItem.cdnRoot) {
        //     environment.cdnRoot = environmentConfigItem.cdnRoot;
        // }
        if (this.environmentConfigItem.stripePublicKey) {

            if (!(globalThis as any).Stripe) {
                console.warn('Stripe.js not loaded');
            } else {
                globalThis.stripe = {
                    core: (globalThis as any).Stripe(this.environmentConfigItem.stripePublicKey),
                    key: this.environmentConfigItem.stripePublicKey
                }
            }
        }

        dwCoreConfig.tenantKey = (environment as any).tenantKey;

        if (this.environmentConfigItem.envMessage == 'Dev') {
            DwFormDebugService.showAllMessages = false;
            DwFormDebugService.componentNameList = ['Training', 'DwContextConfigurationBase', 'DwMetadataFormBuilderService'];
            DwFormDebugService.componentNameList = [];
            DwFormDebugService.disableLogging = true;
        }

        // configure logging
        dwCoreConfig.loggingConfig.writeAllToConsole = (environment as any).enableConsoleLogging;

        dwCoreConfig.loggingConfig.serverMessagePrefix = 'Client: ';
        dwCoreConfig.loggingConfig.writeToServerLevels = [DwLogSeverity.error];

        dwCoreConfig.loggingConfig.logSlowApiCalls.elapsedTimeThresholdMs = 30000;

        // Override the default CanActivate guard
        dwCoreConfig.routingConfig.defaultCanActivateGuards = [DwAuthGuardService, AviatorRouteGuardService];
        dwCoreConfig.routingConfig.googleAnalyticsTrackingToken = environment.googleAnalyticsTrackingToken;

        // Setup security anomymous access
        dwCoreConfig.securityConfig.allowAnonymousAccess = true;
        dwCoreConfig.securityConfig.securityTokenTimeoutMinutes = 5;

        dwCoreConfig.securityConfig.autoLoginAfterRegistration = true;

        dwCoreConfig.securityConfig.alwaysShowRouterOnPathsFunc = (path: string, securityState: DwSecurityState) => {
            return !securityState.isAuthenticated;
        }


        dwCoreConfig.routingConfig.defaultRouteUrl = '';;

        dwCoreConfig.autoUpdateConfig.checkforAngularUpdates = true;
        dwCoreConfig.autoUpdateConfig.updateMessageTooltip = 'Refresh your browser to get the latest version of the app';

        dwCoreConfig.securityConfig.alwaysShowRouterOnLoginPaths = ['login', ''];

        dwCoreConfig.securityConfig.showAuthenticationMessage = (path: String, securityState: DwSecurityState) => {
            //console.log(`showAuthenticationMessage - ${securityState.authenticationType}`, securityState);

            switch (securityState.authenticationType) {
                case DwAuthenticationType.login:
                    return false;
                case DwAuthenticationType.init:
                    if (!securityState.isAuthenticated) {
                        return false;
                    }
            }

            return true;
        };

        //dwCoreConfig.autoUpdateConfig.updateMessage = 30;

        if (!environment.disabledUserInactvityTimeout) {
            dwCoreConfig.securityConfig.userInactivitiy = {
                warningTimeoutMinutes: 58,
                warningMessage: 'You will be logged out in 2 minutes due to inactivity.',
                logoutTimeoutMinutes: 60,
                logoutMessage: 'You have been logged out due to inactivity.'
            }

            dwCoreConfig.securityConfig.userInactivitiyPermissionOveride = {};

            dwCoreConfig.securityConfig.userInactivitiyPermissionOveride[AppPermissions.lMSNoSessionLogout] = {} as any;

            // Handle in Course inactivity 
            dwCoreConfig.securityConfig.userInactivtyFunc = (securityState: DwSecurityState) => this.getUserInactivityConfig(securityState);
        }

        if ((environment as any).userInactivitiyOverride) {
            dwCoreConfig.securityConfig.userInactivitiyPermissionOveride = {};
            dwCoreConfig.securityConfig.userInactivitiy = (environment as any).userInactivitiyOverride;
        }
    }

    getUserInactivityConfig(securityState: DwSecurityState): DwUserInactivityConfig {
        if (this.onCourseRoute()) {
            const userInactivitiy: DwUserInactivityConfig = {
                warningTimeoutMinutes: 13,
                warningMessage: 'You will be logged out in 2 minutes due to inactivity.',
                logoutTimeoutMinutes: 15,
                logoutMessage: 'You have been logged out due to inactivity.'
            };

            return userInactivitiy;
        }

        return null;
    }

    onCourseRoute() {
        const url = this.router.url;

        if (url.includes("my-courses/") && url.includes("module")) {
            return true;
        }

        return false;
    }

    public static getEnvironmentConfigItem(): EnvironmentConfigItem {
        const mainEnvironment = environment.environment;
        const altEnvironment = (environment as any).altEnvironment;

        if (!altEnvironment) {
            return mainEnvironment;
        }

        if (altEnvironment.hostNameMatch) {
            const hostName = window.location.hostname;

            if (hostName == altEnvironment.hostNameMatch) {
                return altEnvironment;
            }
        }

        return mainEnvironment;
    }

    private static getTitleEnvironmentConfig(): EnvironmentConfigItem {
        return AppDevwareConfigProviderService.getRuntimeEnvironmentConfig()
            || AppDevwareConfigProviderService.getEnvironmentConfigItem();
    }

    private static getRuntimeEnvironmentConfig(): EnvironmentConfigItem {
        const environmentName = (AppDevwareConfigProviderService.runtimeEnvironmentInfo?.EnvironmentName || '').toString().trim().toLowerCase();

        switch (environmentName) {
            case 'local':
                return AppDevwareConfigProviderService.buildEnvironmentConfig(EnvironmentNames.testlocal, 'LOCAL', '🟢');
            case 'development':
            case 'dev':
                return AppDevwareConfigProviderService.buildEnvironmentConfig(EnvironmentNames.dev, 'DEV', '🔵');
            case 'test':
                return AppDevwareConfigProviderService.buildEnvironmentConfig(EnvironmentNames.test, 'TEST', '🟠');
            case 'staging':
            case 'stage':
                return AppDevwareConfigProviderService.buildEnvironmentConfig(EnvironmentNames.stage, 'STAGE', '🟡');
            case 'production':
            case 'prod':
                return AppDevwareConfigProviderService.buildEnvironmentConfig(EnvironmentNames.prod, 'PROD', '🔴');
        }

        return null;
    }

    private static buildEnvironmentConfig(envKey: EnvironmentNames, environmentLabel: string, environmentEmoji: string): EnvironmentConfigItem {
        const baseEnvironmentConfig = AppDevwareConfigProviderService.getEnvironmentConfigByKey(envKey) || {} as EnvironmentConfigItem;

        return {
            ...baseEnvironmentConfig,
            envKey,
            environmentLabel,
            environmentEmoji,
        };
    }

    private static getEnvironmentConfigByKey(environmentKey: EnvironmentNames): EnvironmentConfigItem {
        const environmentConfigs = [environment.environment, (environment as any).altEnvironment]
            .filter(envConfig => !!envConfig) as EnvironmentConfigItem[];

        const existingConfig = environmentConfigs.find(envConfig => envConfig.envKey === environmentKey);

        if (existingConfig) {
            return existingConfig;
        }

        switch (environmentKey) {
            case EnvironmentNames.dev:
                return { envKey: EnvironmentNames.dev, environmentLabel: 'DEV', environmentEmoji: '🔵', apiRoot: '' };
            case EnvironmentNames.test:
                return { envKey: EnvironmentNames.test, environmentLabel: 'TEST', environmentEmoji: '🟠', apiRoot: '' };
            case EnvironmentNames.testlocal:
                return { envKey: EnvironmentNames.testlocal, environmentLabel: 'LOCAL', environmentEmoji: '🟢', apiRoot: '' };
            case EnvironmentNames.stage:
                return { envKey: EnvironmentNames.stage, environmentLabel: 'STAGE', environmentEmoji: '🟡', apiRoot: '' };
            case EnvironmentNames.prod:
                return { envKey: EnvironmentNames.prod, environmentLabel: 'PROD', environmentEmoji: '🔴', apiRoot: '' };
        }

        return null;
    }

    private static isLocalHost(): boolean {
        if (typeof window === 'undefined') {
            return false;
        }

        const hostName = (window.location.hostname || '').toLowerCase();

        return hostName === 'localhost'
            || hostName === '0.0.0.0'
            || hostName === '::1'
            || hostName === '[::1]'
            || hostName.startsWith('127.');
    }

    private static isLocalApi(): boolean {
        const apiRoot = AppDevwareConfigProviderService.getEnvironmentConfigItem()?.apiRoot;

        if (!apiRoot) {
            return false;
        }

        try {
            const apiHostName = new URL(apiRoot).hostname.toLowerCase();

            return apiHostName === 'localhost'
                || apiHostName === '0.0.0.0'
                || apiHostName === '::1'
                || apiHostName === '[::1]'
                || apiHostName.startsWith('127.');
        } catch (e) {
            return false;
        }
    }

    private static getEnvironmentOrb(environmentConfig: EnvironmentConfigItem): string {
        const environmentEmoji = (environmentConfig?.environmentEmoji || '').trim();
        return environmentEmoji || '';
    }


    configureAdditionalConfig(configName: string, config: any, dwCoreConfig: DwCoreConfig) {
        switch (configName) {
            case DwUiConfigName:
                this.configureUIConfig(config, dwCoreConfig);
                break;

            case DwUIMetaDataConfigDefaults.configName:
                this.configureUIMetaDataConfig(config);
                break;

            case DwMediaConfigName:
                this.configureMediaConfig(config, dwCoreConfig);
        }
    }


    private configureUIConfig(dwUiConfig: DwUIConfig, dwCoreConfig: DwCoreConfig) {


        // Setup Contact us menu
        dwUiConfig.showContactUs = environment.showContactUs;
        dwUiConfig.contactUsEMail = environment.contactUsEmail;

        dwUiConfig.gridComponent = DwAgGridComponent;
        dwUiConfig.pageFooterHeight = 0;
        dwUiConfig.showFooter = false;

        dwUiConfig.allowConfiguration = environment.allowConfiguration;

        dwCoreConfig.globals.apiRoot = dwCoreConfig.apiRoot;
        dwCoreConfig.globals.defaultAvatar = dwUiConfig.defaultAvatarImageUrl;
        //dwCoreConfig.securityConfig.l

        dwUiConfig.defaultBackgroundImageUrl = '';
        dwUiConfig.emailValidationRegEx = /^\w+([\.-]?\w+)*@\w+([\.-]?\w+)*(\.\w{2,50})+$/;

        dwUiConfig.emailValidationRegEx = /^[a-zA-Z0-9._%+-]+@[a-zA-Z0-9.-]+\.[a-zA-Z]{2,}$/;

        dwUiConfig.defaultAvatarImageUrl = 'assets/img/user-avatar.png';
        dwUiConfig.minimumButtonSpinnerDisplayTime = 750;

        // Customize the registration process
        dwUiConfig.registrationConfig = {
            registerTitle: 'Sign up for an account',
            registerButtonText: 'Sign up',
            registrationComponentKey: 'aviator-online-user-registration-extension',
            registrationShowAsLink: true,
            registrationLinkText: `Don't have an account?`,
            useFloatLabelOnLogin: true,
            useFloatLabelOnRegistration: true,
            userNameText: 'Email',
            registrationHideUserName: true,
            capchtaConfig: {
                enableCaptcha: true,
                siteKey: '6LeeHsEqAAAAAIYVbQMz7eZktr9d1x3Fv5_gK4Wc'
            },
            loginRegistrationInfoProviderService: DwLoginRegistrationInfoProviderService
        };

        dwUiConfig.breadcrumbConfig = {
            hideMobile: (breadcrumbs: DwBreadcrumbMenu[], currentBreadcrumb, currentIndex) => {
                if (currentBreadcrumb?.display == 'Lesson') {
                    return true;
                }
                if (currentBreadcrumb?.display == 'Module' && breadcrumbs.length < 5) {
                    return true;
                }

                const resourceBreadcrumb = breadcrumbs.find(b => b.display == 'Resources');
                if (resourceBreadcrumb) {
                    const hasView = !!breadcrumbs.find(b => b.breadcrumbDisplay == 'View' || b.breadcrumbDisplay == 'Edit');

                    let hideMobile: boolean;


                    if (hasView) {
                        if (currentIndex == breadcrumbs.length - 3) {
                            hideMobile = false;
                        }
                    }

                    //console.log(`${currentIndex} ${currentBreadcrumb.breadcrumbDisplay}(${currentBreadcrumb.finalUrl}) Hide Mobile: ${hideMobile || 'Deferred'}`, breadcrumbs);

                    return hideMobile;
                }

                //return false;
                // console.warn('breadcrumbConfig.hideMobile not configured for ', currentBreadcrumb);
            }
        }

        dwUiConfig.securityInfoConfig = {
            showWelcome: false,
            getNameDisplay: (user, emulating, config, nameOnly) => {
                if (!user) {
                    return '';
                }

                // Side-effect: keep <body class="is-emulating"> in sync so CSS
                // can render the "EMULATING" pill in the navbar trigger. The
                // framework calls this on every security-context change, so the
                // class stays accurate without a separate observable subscription.
                if (typeof document !== 'undefined') {
                    document.body.classList.toggle('is-emulating', !!emulating);
                }

                const currentUserDisplay = user.FirstNameLastName;

                if (!nameOnly) {
                    if (config.showWelcome) {
                        return 'Welcome ' + currentUserDisplay;
                    }
                    // Emulating: name only — CSS shows the "EMULATING" pill via body.is-emulating
                }

                return currentUserDisplay;
            },
            getAdditionalLine: (user, emulating, config) => {
                const adminManagerService = this.injector.get(AdminManagerService);

                const aviatorUser = adminManagerService.getAviatorUser(user);

                switch (aviatorUser?.UserTypeId) {
                    case AviatorOnlineUserTypeIds.flightSchool:
                        return 'Flight School';
                    case AviatorOnlineUserTypeIds.student:
                        return 'Student';
                    case AviatorOnlineUserTypeIds.flightInstructor:
                        const schoolRepositoryService = this.injector.get(SchoolRepositoryService);

                        return schoolRepositoryService.hasFeatureWithLoad(SubscriptionFeatureKeys.Assignments)
                            .pipe(map((hasAssignmentFeature) => hasAssignmentFeature ? 'Instructor' : 'Student'
                            ));
                    //return of('Instructor 2');
                    case AviatorOnlineUserTypeIds.aviatorOnlineAdmin:
                        return 'LMS Admin';
                }
            }
        }

        dwUiConfig.layoutOverides = {
            securityInfoComponent: undefined,
            autoUpdateCheckerComponent: undefined,
            offlineComponent: undefined,
            securityMessageComponent: undefined,
        }

        dwUiConfig.enableThemes = true;
    }

    private configureUIMetaDataConfig(dwUiMetaDataConfig: DwUIMetaDataConfig) {
        // Default date/time configuration
        dwUiMetaDataConfig.useGmtDateTime = true; 
        dwUiMetaDataConfig.use24HourTime = false;
        dwUiMetaDataConfig.pdfRenderWaitTimeMs = 1200;
        dwUiMetaDataConfig.emailValidationRegEx = /^\w+([\.-]?\w+)*@\w+([\.-]?\w+)*(\.\w{2,50})+$/;;

        dwUiMetaDataConfig.gridDefaultPreferences.rowHeight = 25;
        dwUiMetaDataConfig.gridGlobalDefaults.hideConfiguringGrid = true;

        dwUiMetaDataConfig.userContextExtendedAttributes = [
            { name: 'UserTypeId', display: 'User Type', attrType: DwAttributeType.Integer, controlType: DwControlType.DropDownList, lookupId: 137 }
        ];

        this.setupSkeletonLoading(dwUiMetaDataConfig);

    }

    configureMediaConfig(config: DwMediaConfig, dwCoreConfig: DwCoreConfig) {
        config.defaultMaxFileSizeMb = 10;

        config.cdnSettings = {
            useCDN: this.environmentConfigItem.useCDN && !!this.environmentConfigItem?.cdnRoot,
            cdnUrl: this.environmentConfigItem?.cdnRoot,
        }

        config.webImageFileExtensions = "jpg,jpeg,gif,png,bmp,webp,svg";
    }

    setupSkeletonLoading(dwUiMetaDataConfig: DwUIMetaDataConfig) {
        // setup the default loading definition to be centered (overrides the framework default of left-aligned)
        const centeredFormSkeletonConfig: DwFormSkeletonLoadingConfig = {
            alignment: 'center',
            maxWidth: 1232
        };

        dwUiMetaDataConfig.defaultLoadingDefinitions = {
            ...dwUiMetaDataConfig.defaultLoadingDefinitions,
            [DwUiConfigType.form.toString()]: {
                ...(dwUiMetaDataConfig.defaultLoadingDefinitions?.[DwUiConfigType.form.toString()] || {}),
                mode: 'skeleton',
                text: 'Loading',
                componentKey: 'dw-form-loading-skeleton',
                config: {
                    ...((dwUiMetaDataConfig.defaultLoadingDefinitions?.[DwUiConfigType.form.toString()]?.config as DwFormSkeletonLoadingConfig) || {}),
                    ...centeredFormSkeletonConfig
                }
            }
        };

        const manageUsersSkeletonConfig: DwFormSkeletonLoadingConfig = {
            alignment: 'center',
            maxWidth: '1232px',
            layout: [
                { type: 'avatarBanner', variant: 'enhanced', height: 312 },
                { type: 'cardStack', count: 3 },
                { type: 'form', heading: true, columns: 2, rows: 5 }
            ]
        };
        // Mirrors the loaded profile page: hero banner, Account Status tiles,
        // Additional Details, Address, then the endorsements grid card.
        const userProfileSkeletonConfig: DwFormSkeletonLoadingConfig = {
            alignment: 'center',
            maxWidth: '1232px',
            layout: [
                { type: 'avatarBanner', variant: 'enhanced', height: 312 },
                { type: 'form', heading: true, columns: 3, rows: 1 },
                { type: 'form', heading: true, columns: 2, rows: 3 },
                { type: 'form', heading: true, columns: 2, rows: 3 },
                { type: 'form', heading: true, columns: 1, rows: 2 }
            ]
        };
        const assignmentFlightSchoolSkeletonConfig: DwFormSkeletonLoadingConfig = {
            alignment: 'center',
            maxWidth: '1232px',
            layout: [
                { type: 'form', heading: true, columns: 2, rows: 4 },
                { type: 'form', heading: true, columns: 2, rows: 4 }
            ]
        };
        const assignmentFlightSchoolAddModalSkeletonConfig: DwFormSkeletonLoadingConfig = {
            alignment: 'center',
            maxWidth: '1232px',
            layout: [
                { type: 'form', heading: false, columns: 1, rows: 1 },
                { type: 'form', heading: true, columns: 2, rows: 8 }
            ]
        };


        dwUiMetaDataConfig.configLoadingDefinitions = dwUiMetaDataConfig.configLoadingDefinitions || {};
        dwUiMetaDataConfig.configLoadingDefinitions[getUiLoadingConfigKey('dw_User-profile', DwUiConfigType.form)] = {
            mode: 'skeleton',
            text: 'Loading Profile',
            componentKey: 'dw-form-loading-skeleton',
            minDisplayMs: 450,
            config: userProfileSkeletonConfig
        };
        dwUiMetaDataConfig.configLoadingDefinitions[getUiLoadingConfigKey('dw_User-flight-school-manage-users', DwUiConfigType.form)] = {
            mode: 'skeleton',
            text: 'Loading User',
            componentKey: 'dw-form-loading-skeleton',
            minDisplayMs: 450,
            config: manageUsersSkeletonConfig
        };
        dwUiMetaDataConfig.configLoadingDefinitions[getUiLoadingConfigKey('Assignment-Flight-school', DwUiConfigType.form)] = {
            mode: 'skeleton',
            text: 'Loading Assignment',
            componentKey: 'dw-form-loading-skeleton',
            minDisplayMs: 450,
            config: assignmentFlightSchoolSkeletonConfig
        };
        dwUiMetaDataConfig.configLoadingDefinitions[getUiLoadingConfigKey('Assignment-Flight-school-add-modal', DwUiConfigType.form)] = {
            mode: 'skeleton',
            text: 'Loading Assignment',
            componentKey: 'dw-form-loading-skeleton',
            minDisplayMs: 450,
            config: assignmentFlightSchoolAddModalSkeletonConfig
        };
    }



    @DwUiConfigInitDecorator({
        name: 'AviatorUiConfigInit',
        useDI: true,
    })
    setupRegistrations() {
        // this.setupContainerStyles();
        // this.setupButtonContainerStyles();
        this.setupGridStyles();
        // Resolved lazily: the registration service needs DwUiConfigService, which
        // depends on this provider, so a constructor injection would be cyclic.
        this.injector.get(QuestionFormLayoutWidgetRegistrationService).register(QuestionFormLayoutWidgetComponent);
        this.injector.get(QuizFormLayoutWidgetRegistrationService).register(QuizFormLayoutWidgetComponent);
        // this.setupListStyles();
        // this.registerComponents();
    }

    private setupGridStyles() {

        this.uiConfigRegistyService.registerItem(DwUiRegistryType.gridStyles, <DwUiGridStyleReference>{
            keyName: 'aviator-large',
            display: 'Aviator - large',
            containerClass: 'dw-grid-container dw-grid-font-large aviator-large-grid',
            filterHeaderClass: 'dw-grid-filter-header',
            filterBodyClass: 'dw-grid-filter-body',
            actionBarClass: 'dw-grid-action-bar',
            rowHeight: 50,
        });

    }
}
